// src/main.tsx
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./app/App";
import { Toaster } from "./shared/components/ui/sonner";
import "./styles/globals.css"; // ✅ ONLY global css
import { ErrorBoundary } from "./shared/components/common/ErrorBoundary";
import { AppProviders } from "./app/providers/AppProviders";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <AppProviders>
        <App />
        <Toaster className={".dark"} />
      </AppProviders>
    </ErrorBoundary>
  </StrictMode>,
);
